function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJcb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 300 231.511"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.82152 0 0 1.82152 -17.944 -13.026)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M174 108.3c0 14-11.4 25.4-25.4 25.4H10.4V33.1c0-14 11.4-25.4 25.4-25.4H174z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb_svg__a",
  x1: 117.386,
  x2: 157.33,
  y1: 81.399,
  y2: 81.399,
  gradientTransform: "translate(-11.976 -13.861)scale(1.125)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#007940"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.229,
  style: {
    stopColor: "#00873f"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.743,
  style: {
    stopColor: "#40a737"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#5cb531"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M129 82.5h10.5c.3 0 1-.1 1.3-.1 2-.4 3.7-2.2 3.7-4.7 0-2.4-1.7-4.2-3.7-4.7-.3-.1-.9-.1-1.3-.1H129z",
  style: {
    fill: "url(#jcb_svg__a)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb_svg__b",
  x1: 117.384,
  x2: 157.332,
  y1: 75.171,
  y2: 75.171,
  gradientTransform: "translate(-11.976 -13.861)scale(1.125)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#007940"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.229,
  style: {
    stopColor: "#00873f"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.743,
  style: {
    stopColor: "#40a737"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#5cb531"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M138.3 16.2c-10 0-18.2 8.1-18.2 18.2v18.9h25.7c.6 0 1.3 0 1.8.1 5.8.3 10.1 3.3 10.1 8.5 0 4.1-2.9 7.6-8.3 8.3v.2c5.9.4 10.4 3.7 10.4 8.8 0 5.5-5 9.1-11.6 9.1H120v37h26.7c10 0 18.2-8.1 18.2-18.2V16.2z",
  style: {
    fill: "url(#jcb_svg__b)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb_svg__c",
  x1: 117.385,
  x2: 157.331,
  y1: 68.399,
  y2: 68.399,
  gradientTransform: "translate(-11.976 -13.861)scale(1.125)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#007940"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.229,
  style: {
    stopColor: "#00873f"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.743,
  style: {
    stopColor: "#40a737"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#5cb531"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M143.2 63.1c0-2.4-1.7-4-3.7-4.3-.2 0-.7-.1-1-.1H129v8.8h9.5c.3 0 .9 0 1-.1 2-.3 3.7-1.9 3.7-4.3",
  style: {
    fill: "url(#jcb_svg__c)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb_svg__d",
  x1: 27.959,
  x2: 68.522,
  y1: 75.171,
  y2: 75.171,
  gradientTransform: "translate(-11.976 -13.861)scale(1.125)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#1f286f"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.475,
  style: {
    stopColor: "#004e94"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.826,
  style: {
    stopColor: "#0066b1"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#006fbc"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M37.7 16.2c-10 0-18.2 8.1-18.2 18.2v44.9c5.1 2.5 10.4 4.1 15.7 4.1 6.3 0 9.7-3.8 9.7-9V53.2h15.6v21.1c0 8.2-5.1 14.9-22.4 14.9-10.5 0-18.7-2.3-18.7-2.3v38.3h26.7c10 0 18.2-8.1 18.2-18.2V16.2z",
  style: {
    fill: "url(#jcb_svg__d)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb_svg__e",
  x1: 72.46,
  x2: 111.855,
  y1: 75.171,
  y2: 75.171,
  gradientTransform: "translate(-11.976 -13.861)scale(1.125)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#6c2c2f"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.173,
  style: {
    stopColor: "#882730"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.573,
  style: {
    stopColor: "#be1833"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.859,
  style: {
    stopColor: "#dc0436"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#e60039"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M88 16.2c-10 0-18.2 8.1-18.2 18.2v23.8c4.6-3.9 12.6-6.4 25.5-5.8 6.9.3 14.3 2.2 14.3 2.2v7.7c-3.7-1.9-8.1-3.6-13.8-4-9.8-.7-15.7 4.1-15.7 12.5 0 8.5 5.9 13.3 15.7 12.5 5.7-.4 10.1-2.2 13.8-4V87s-7.3 1.9-14.3 2.2c-12.9.6-20.9-1.9-25.5-5.8v42h26.7c10 0 18.2-8.1 18.2-18.2v-91z",
  style: {
    fill: "url(#jcb_svg__e)"
  }
})));
export default SvgJcb;